import $axios from '@/axios-instance.js'

export class ContentLibrariesService {
  baseUrl = '/api/v1/admin/content-libraries'
  static make() {
    return new ContentLibrariesService()
  }
  // Create
  store(params) {
    return $axios.post(this.baseUrl, params)
  }

  // Read all - findAll
  index(params) {
    return $axios.get(this.baseUrl, params)
  }

  // Read one - show
  show(uuid, params) {
    return $axios.get(this.baseUrl + `/${uuid}`, params)
  }

  // Update
  update(id, params) {
    return $axios.put(this.baseUrl + `/${id}`, params)
  }

  // Delete - delete
  destroy(id, params) {
    return $axios.delete(this.baseUrl + `/${id}`, params)
  }
}
